module.exports = __webpack_public_path__ + "static/media/smart-banner-icon.1e3df884.png";